import React from 'react';
import './styles/Home.css'
import Product from './Product'



function Home() {
    return (
        <div className="home">
            <div className="home__container">
                <img  className="home__image" src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Hero/Fuji_TallHero_45M_v2_1x._CB432458380_.jpg" alt="" />
                
                <div className="home__row">
                    <Product
                    id="12321341"
                     title = 'ASUS VivoBook L203MA Laptop, 11.6” HD Display, Intel Celeron Dual Core CPU, 4GB RAM, 64GB Storage, USB-C, Windows 10 Home In S Mode, Up To 10 Hours Battery Life, One Year of Microsoft 365, L203MA-DS04'
                     price = {249.66}
                    image = "https://images-na.ssl-images-amazon.com/images/I/81o8Tll-5-L._AC_SX522_.jpg"
                    rating={5} />
                    <Product 
                    id = "49538094"
                    price={32.52}
                    title = "RUNMUS Gaming Headset Xbox One Headset with 7.1 Surround Sound, PS4 Headset with Noise Canceling Mic & LED Light, Compatible with PC, PS4, Xbox One Controller(Adapter Not Included)"
                    image = "https://images-na.ssl-images-amazon.com/images/I/61lnzTv2a0L._AC_SX466_.jpg"
                    rating = {5}/>
                </div>
                  <div className="home__row">
                    <Product
                    id ="1231232"
                    price={129.99}
                    title="Sceptre 24 Curved 75Hz Gaming LED Monitor Full HD 1080P HDMI VGA Speakers, VESA Wall Mount Ready Metal Black 2019 (C248W-1920RN)"
                    image = "https://m.media-amazon.com/images/I/81mHL0psH-L._AC_UY218_.jpg"
                    rating = {5}    
                    />
                    <Product
                     id ="1231242"
                     price={7.35}
                     title = "Mkeke Compatible with iPhone XR Case,Clear Anti-Scratch Shock Absorption Cover Case for iPhone XR"
                     image = "https://images-na.ssl-images-amazon.com/images/I/71j2Zqi6BGL._AC_SX569_.jpg" 
                      rating = {5}  
                     />
                    <Product
                     id ="1231222"
                     price={54.88}
                     title = "Xbox Wireless Controller - Red"
                     image = "https://images-na.ssl-images-amazon.com/images/I/71MD3ultk-L._SX342_.jpg" 
                     rating = {5}  
                     />
                   
                </div>
                  <div className="home__row">
                    <Product
                     id ="12312322"
                     price={275.75}
                     title = "Blendtec Total Classic Original Blender - WildSide+ Jar (90 oz) - Professional-Grade Power - 6 Pre-programmed Cycles - 10-speeds - Black (Renewed)"
                     image = "https://images-na.ssl-images-amazon.com/images/I/71zrQU%2ByLvL._AC_SL1500_.jpg"
                    rating = {5}  
                    />
                </div>
                

            </div>
        </div>
    )
}

export default Home;
